import { Theme } from "@mui/material";
import { TypographyOptions } from "@mui/material/styles/createTypography";
import { ComponentsVariants } from "@mui/material/styles/variants";

// Base configuration for typography
export const baseTypography: TypographyOptions = {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeightRegular: 500,
    fontFamilyBrand: {
        fontFamily: 'var(--font-family-Brand)',
    },
    labelMediumBold: {
        fontFamily: 'var(--font-family-Core)',
        fontSize: 'var(--font-size-md)',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'var(--font-line-height-sm)',
    },
    labelLargeBold: {
        fontFamily: 'var(--font-family-Core)',
        fontSize: 'var(--font-size-lg)',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'var(--font-line-height-md)',
    },
    labelSmallBold: {
        fontFamily: 'var(--font-family-Core)',
        fontSize: 'var(--font-size-sm)',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'var(--font-line-height-xs)',
    },
    displayXXSmall: {
        fontFamily: 'var(--font-family-Brand)',
        fontSize: 'var(--font-size-xl)',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'var(--font-line-height-lg)',
    },
    title4: {
        fontFamily: 'var(--font-family-Brand)',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '16px',
    },
    body1: {
        color: 'var(--text-primary, #FFF)'
    },
    paragraphSmall: {
        fontFamily: 'var(--font-family-Core)',
        fontSize: 'var(--font-size-sm)',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'var(--font-line-height-xs)',
    },
};


export const baseTypographyVariants: ComponentsVariants<Theme>['MuiTypography'] = [
    // heading use Lemon milk pro font
    {
        props: { variant: 'h1' },
        style: {
            fontFamily: "'Lemon milk pro', sans-serif",
            fontWeight: 700,
        },
    },
    {
        props: { variant: 'h2' },
        style: {
            fontFamily: "'Lemon milk pro', sans-serif",
            fontWeight: 700,
        },
    },
    {
        props: { variant: 'h3' },
        style: {
            fontFamily: "'Lemon milk pro', sans-serif",
            fontWeight: 700,
        },
    },
    {
        props: { variant: 'h4' },
        style: {
            fontFamily: "'Lemon milk pro', sans-serif",
            fontWeight: 700,
        },
    },
    {
        props: { variant: 'h5' },
        style: {
            fontFamily: "'Lemon milk pro', sans-serif",
            fontWeight: 700,
        },
    },
    {
        props: { variant: 'h6' },
        style: {
            fontFamily: "'Lemon milk pro', sans-serif",
            fontWeight: 700,
        },
    },
    {
        props: { variant: 'subtitle1' },
        style: {
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontSize: '1.5rem',
        },
    },
    {
        props: { variant: 'body1' },
        style: {
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontSize: '1rem',
        },
    },
    {
        props: { variant: 'body14' },
        style: {
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '20px',
        },
    },
];
